<div class="modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Internal Notes</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(notes) || null }">
          <span class="ey-float-label ey-textarea-label" title="Enter a internal notes">
            <textarea
              appAutosize
              class="form-control"
              id="notes"
              name="notes"
              [(ngModel)]="internalnotes"
              #notes="ngModel"
              [disabled]="readOnly"
              required
              maxlength="512"
              minRows="2"
              minHeight="48"
              paddingHeight="32"
              appLabelFloat
            ></textarea>
            <label for="notes">Internal Notes</label>
          </span>
          <span class="help-block" *ngIf="ShowValidationMessage(notes) && notes.errors.required"> An internal notes is required </span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="readOnly">Save</button>
  </div>
</div>
